/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  var Config = window.OletLens.Config || {};
  var Utils = window.OletLens.Utils || {};

  function getSelection() {
    var active = document.querySelectorAll('.lens-addon.active');
    var result = [];
    active.forEach(function (el) {
      var key = el.getAttribute('lens-addon');
      if (key) result.push(key);
    });
    return result;
  }

  function syncDomToAddons(addons) {
    var list = Array.isArray(addons) ? addons : [];
    var addonEls = document.querySelectorAll('.lens-addon');
    addonEls.forEach(function (el) {
      var key = el.getAttribute('lens-addon');
      if (!key) return;
      if (list.indexOf(key) !== -1) {
        el.classList.add('active', '!border-[#009AD6]', '!bg-[#E6F7FF]');
      } else {
        el.classList.remove('active', '!border-[#009AD6]', '!bg-[#E6F7FF]');
      }
    });
  }

  function validateCompatibility(usageType, app) {
    var selection = app && app.state && Array.isArray(app.state.addons) ? app.state.addons.slice() : getSelection();

    var removed = [];
    selection.forEach(function (addon) {
      if (!Utils.isAddonCompatible(addon, usageType)) {
        removed.push(addon);
      }
    });

    var nextAddons = selection.filter(function (addon) {
      return removed.indexOf(addon) === -1;
    });

    if (app && typeof app.setState === 'function') {
      app.setState('addons', nextAddons);
      syncDomToAddons(nextAddons);
      if (typeof app.calculateTotalPrice === 'function') {
        app.calculateTotalPrice();
        syncDomToAddons(nextAddons);
      }
    } else {
      syncDomToAddons(nextAddons);
    }

    return { valid: removed.length === 0, removed: removed };
  }

  function handleSelection(element, app) {
    var addonType = element.getAttribute('lens-addon');
    if (!addonType) return;

    var currentAddons = app && app.state && Array.isArray(app.state.addons) ? app.state.addons.slice() : [];

    var isSelected = currentAddons.indexOf(addonType) !== -1;

    var nextAddons;
    if (isSelected) {
      // deselect
      nextAddons = currentAddons.filter(function (key) {
        return key !== addonType;
      });
    } else {
      // select
      nextAddons = currentAddons.slice();
      nextAddons.push(addonType);
    }

    // 1. Optimistic DOM update so user sees feedback instantly
    syncDomToAddons(nextAddons);

    // 2. Persist to state (triggers pubsub → syncUIForCurrentStep → DOM wipe)
    if (app && typeof app.setState === 'function') {
      app.setState('addons', nextAddons);
      // 3. Restore DOM because step 2 wiped our classes
      syncDomToAddons(nextAddons);

      if (typeof app.calculateTotalPrice === 'function') {
        app.calculateTotalPrice();
        // 4. Restore again in case calculateTotalPrice triggered further renders
        syncDomToAddons(nextAddons);
      }
    }
  }

  function renderOptions(usageType) {
    void usageType;
  }

  function init(app) {
    document.addEventListener('click', function (e) {
      var el = e.target && typeof e.target.closest === 'function' ? e.target.closest('.lens-addon') : null;
      if (el) handleSelection(el, app);
    });
  }

  window.OletLens.AddonsModule = {
    init: init,
    handleSelection: handleSelection,
    getSelection: getSelection,
    syncDomToAddons: syncDomToAddons,
    validateCompatibility: validateCompatibility,
    renderOptions: renderOptions,
  };
})();
